import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { CalendarEvent, CalendarEvents, FetchCalendarEventsRequest } from '../../../shared/models/hospitalProfile.model';
import EventCalender from './eventCalendar/EventCalendar';
import './Calendar.less';
import { Row, Col, Skeleton } from 'antd';
import UpComingEvents from './events/UpComingEvents';
import ScheduledCalendars from './events/ScheduledCalendars';
import { GUTTOR_SPACE, PROFILE_CONSTANTS } from '../../../shared/constants/commonConstants';
import { fetchCalendar } from '../../../store/actions/hospitalAction';
import { useDispatch, useSelector } from 'react-redux';
import AddCalendar from './addCalendar/AddCalendar';
import { propertyBasedSort } from './../../../utils/utility';
import { CAL_EVENTS_CATEGORY } from './../../../shared/constants/commonConstants';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import ApplicationDetail from './../../../shared/services/applicationDetail.service';
import { dashBoardRequest } from '../../../store/actions/leftSideBarAction';
import { FETCH_DASHBOARD } from '../../../shared/constants/urlEndPoints';

const Calender = (): ReactElement => {
  let calendarValue: CalendarEvent[] = [];
  const [isDataLoaded, setIsDataLoaded] = useState(true);
  const ref = useRef({ isEdit: false });
  const dispatch = useDispatch();
  const apiCalendarEvent = useSelector(({ hospital: { calendarEvents } }: any): CalendarEvents[] => calendarEvents);

  useEffect((): void => {
    dispatch(dashBoardRequest({
      title: PROFILE_CONSTANTS.hospitalProfile,
      url: `${process.env.REACT_APP_BASE_URL}${FETCH_DASHBOARD}`, type: PROFILE_CONSTANTS.profile,
    }));
    if (apiCalendarEvent && apiCalendarEvent[0] === null) {
      calendarValue = [];
      fetchCalendarEvents();
    }
    // eslint-disable-next-line
  }, []);

  const fetchCalendarEvents = (typeId?: number[]): void => {
    const payload: FetchCalendarEventsRequest = {
      applicationId: 12345,
      profileIds: [ApplicationDetail.instance.getProfileId()],
      pageNumber: 1,
      pageSize: 100,
      calendarByProfileId: true,
      calendarByTypeId: typeId ? true : false,
      typeIds: typeId || [CAL_EVENTS_CATEGORY[0]],
    };
    setIsDataLoaded(false);
    dispatch(fetchCalendar({ payload, getApiResponse }));
  };

  const getApiResponse = (isTrue: boolean): any => {
    setIsDataLoaded(true);
    if (!isTrue) {
      calendarValue = [];
    }
  };

  const createCalendarEvent = (calendarEvent: CalendarEvents[]): void => {
    const events: CalendarEvent[] = calendarEvent.map((event: CalendarEvents): CalendarEvent => {
      const { name, startDateTime, endDateTime, description } = event;
      return {
        title: name,
        start: new Date(startDateTime),
        end: new Date(endDateTime),
        resource: { eventInfo: event },
        desc: description,
      };
    });
    calendarValue = events;
  };

  if ((calendarValue && calendarValue.length === 0) ||
    (calendarValue && calendarValue.length > 0 && calendarValue.length !== apiCalendarEvent.length) ||
    (ref.current.isEdit)
  ) {
    if (apiCalendarEvent && apiCalendarEvent[0] !== null && apiCalendarEvent.length > 0) {
      calendarValue = [];
      createCalendarEvent(apiCalendarEvent);
      ref.current.isEdit = false;
    }
  }
  const onSaveCalendar = (edit: boolean = false, typeIds: number[]): void => {
    ref.current.isEdit = edit;
    fetchCalendarEvents(typeIds);
  };
  return (
    <>
      <PageHeader
        pageTitle="Calendar"
        rightComponent={
          (): ReactElement => <AddCalendar onSaveCalendar={onSaveCalendar} />}
      />
      <div className="ant-tabs-content-holder tab-custom-container" style={{ width: '100%', top: '10px'}}>
        <Row gutter={GUTTOR_SPACE} className="calendar">
          {(calendarValue && calendarValue.length > 0 || isDataLoaded) && (
            <>
            <Col className="event-calendar-container" md={18}>
              <EventCalender events={calendarValue} onSaveCalendar={onSaveCalendar} />
              </Col>
              <br />
              <Col span={6} style={{ alignContent: 'center', position: 'absolute', left: '75%', right: '-10%'}}>
                <UpComingEvents events={calendarValue.sort(propertyBasedSort)} />
                <br />
                <ScheduledCalendars events={calendarValue} onSaveCalendar={onSaveCalendar} />
              </Col>
            </>
          )}
          {(calendarValue && !calendarValue.length && !isDataLoaded) && (
            <Skeleton active={true} />
          )}
        </Row>
      </div>
    </>
  );
};

export default Calender;
